import type {
  RecipeConfig,
  RecipeVariantRecord,
  SlotRecipeConfig,
} from "@pandacss/dev";
import { aromaTag } from "./tag";
import { aromaTabs } from "./tabs";
import { aromaNumberInput } from "./numberInput";
import { aromaInput } from "./input";
import { aromaTooltip } from "./tooltip";
import { aromaContextualIcon } from "./contextualIcon";
import { aromaAlert } from "./alert";
import { aromaBadge } from "./badge";
import { aromaButton } from "./button";
import { aromaDropdown } from "./dropdown";
import { aromaTextarea } from "./textarea";
import { aromaDrawer } from "./drawer";
import { aromaModal } from "./modal";
import { aromaSkeleton } from "./skeleton";
import { aromaEmptyState } from "./emptyState";
import { aromaSegmentedControl } from "./segmentedControl";
import { aromaLoader } from "./loader";
import { aromaContextualMenu } from "./contextualMenu";
import { aromaNavMenu } from "./navMenu";
import { aromaSidebar } from "./sidebar";
import { aromaTable } from "./table";
import { aromaSortButton } from "./sortButton";
import { aromaMinitable } from "./minitable";
import { aromaDatepicker } from "./datepicker";
import { aromaDayButton } from "./dayButton";
import { aromaFiguresCard } from "./figuresCard";
import { aromaMessageBubble } from "./messageBubble";
import { aromaLoaderCircle } from "./loaderCircle";
import { aromaTableList } from "./tableList";
import { aromaToggleSwitch } from "./toggleSwitch";
import { aromaDatepickerInput } from "./datepickerInput";
import { aromaCarousel } from "./carousel";
import { aromaBanner } from "./banner";
import { aromaToast } from "./toast";
import { aromaDialog } from "./dialog";
import { aromaToggleButtons } from "./toggleButtons";
import { aromaCheckbox } from "./checkbox";
import { aromaRadio } from "./radio";
import { aromaAvatar } from "./avatar";
import { aromaSectionHeader } from "./sectionHeader";
import { aromaBucket } from "./bucket";
import { aromaNavButton } from "./navButton";
import { aromaField } from "./field";
import { aromaAccordion } from "./accordion";
import { aromaCombobox } from "./combobox";
import { aromaPopover } from "./popover";
import { aromaMonthButton } from "./monthButton";
import {
  aromaDraggableContainer,
  aromaDraggableItem,
  aromaDraggableSignifier,
} from "./draggableContainer";
import { aromaListItem } from "./listItem";
import { aromaMemoBadge } from "./memoBadge";
import { aromaSection } from "./section";

export const recipes: Record<
  string,
  Partial<RecipeConfig<RecipeVariantRecord>>
> = {
  aromaBadge,
  aromaButton,
  aromaSkeleton,
  aromaNavMenu,
  aromaSidebar,
  aromaSortButton,
  aromaDayButton,
  aromaRadio,
  aromaToggleSwitch,
  aromaDraggableContainer,
  aromaMonthButton,
};

export const slotRecipes: Record<string, Partial<SlotRecipeConfig>> = {
  aromaTag,
  aromaAlert,
  aromaTabs,
  aromaNumberInput,
  aromaInput,
  aromaDatepickerInput,
  aromaTooltip,
  aromaContextualIcon,
  aromaDropdown,
  aromaTextarea,
  aromaDrawer,
  aromaModal,
  aromaEmptyState,
  aromaSegmentedControl,
  aromaLoader,
  aromaTable,
  aromaMinitable,
  aromaDatepicker,
  aromaFiguresCard,
  aromaMessageBubble,
  aromaLoaderCircle,
  aromaTableList,
  aromaCarousel,
  aromaBanner,
  aromaToast,
  aromaDialog,
  aromaToggleButtons,
  aromaCheckbox,
  aromaAvatar,
  aromaSectionHeader,
  aromaBucket,
  aromaContextualMenu,
  aromaNavButton,
  aromaField,
  aromaAccordion,
  aromaCombobox,
  aromaDraggableItem,
  aromaDraggableSignifier,
  aromaListItem,
  aromaMemoBadge,
  aromaSection,
  aromaPopover,
};
